import {
  CycloneMarkerOptions,
  TimeLabelOptions
} from '@/components/typhoon_tw/settings'

export class TrackHandler {
  constructor (vm, options) {
    this._vm = vm
    this._map = vm.map
    this._options = options
    this._pastTracks = []
    this._fcstTracks = []
    this._timeLabels = []
    this._map_options = null
    this._options = null
    this._data = null
    this._timeLabelTau = [24, 48, 72]
    this._past_all_init_time_z = []
    this._fcst_all_init_time_z = []
  }

  get pastTrack () {
    return this._pastTracks
  }

  get fcstTrack () {
    return this._fcstTracks
  }

  set data (data) {
    this._data = data
    this.set_availible_init_time_z()
  }

  set selected_init_time_z (selected_init_time_z) {
    this._selected_init_time_z = selected_init_time_z
  }

  set map_options (map_options) {
    this._map_options = map_options
  }

  set options (options) {
    this._options = options
  }

  trigger (type, data) {
    for (let _timelabel of this._timeLabels) {
      if (type === 'time_label:onboard') {
        if (_timelabel.tc_name === data.tc_id) {
          _timelabel.hub.onboard(data.dtime, data.layer)
        }
      }
      if (type === 'time_label:offboard') {
        if (_timelabel.tc_name === data.tc_id) {
          _timelabel.hub.offboard(data.layer)
        }
      }
    }
  }

  initTimeLabel () {
    let all_tcs = this._data.tc_infos
    for (let _tc of all_tcs) {
      if (this._timeLabels.filter((e) => { return e.tc_name === _tc.name }).length === 0) {
        var _timeLabel = new L.TyphoonTW.TimeLabelCarrierHub(
          this._map, _tc.name, {
            format: '%d日(%-a) %H時',
            labelOptions: TimeLabelOptions
          })
        this._timeLabels.push({
          tc_name: _tc.name,
          hub: _timeLabel,
          boarded: false
        })
      }
    }
  }

  refreshTracks () {
    try {

      this._selected_tcs = this._options.selected_tc
      this._selected_srcs = this._options.selected_src
      this._past_selected_srcs = ['CWB']
      this._refreshPastTracks()
      this._refreshFcstTracks()

      // time label
      for (let _timeLabel of this._timeLabels) {
        _timeLabel.hub.setVisible(this._options.show_timelabel)
      }

    } catch (error) {
      console.error(error)
    }
  }

  _refreshPastTracks () {
    if (this._data.track.past) {
      for (let _past of this._data.track.past) {
        let [layer, created] = this.createPastLayer(_past)
        if (layer) {
          layer.setTcNameVisible(this._options.show_timelabel);
        }
      }
      this._updateLayers(this._pastTracks, this._selected_tcs, this._past_selected_srcs, this._past_all_init_time_z)
    }
  }

  _refreshFcstTracks () {
    if (this._data.track.fcst) {
      for (let _fcst of this._data.track.fcst) {
        this.createFcstLayer(_fcst)
      }
      this._updateLayers(this._fcstTracks, this._selected_tcs, this._selected_srcs, this._fcst_all_init_time_z)
    }
  }

  createPastLayer (past_data) {
    let exists_layers = this.getLayer(this._pastTracks, past_data.tc_name, past_data.src)
    if (exists_layers.length === 0) {
      let points = {
        points: TrackHandler.collect_past_points(past_data.track)
      }

      let tc_info = this.get_tc_info(past_data.tc_name)

      if (tc_info) {
        let past_track = new L.TyphoonTW.PastTrack(
          points, {
            markerOptions: {
              iconCase: L.TyphoonTW.FixIconCase,
              source_color: '#999999',
              icon_size: CycloneMarkerOptions.icon_size
            },
            color: '#999999',
            weight: 2,
            opacity: 0.7,
            markerVisible: true
          },
          past_data.src,
          this._data.src_infos,
          tc_info,
          this._options.selected_init_time_z
        )
        past_track.bindTcName()
        this._pastTracks.push(past_track)
        return [past_track, true]
      }
    }
    return [exists_layers[0], false]
  }

  createFcstLayer (fcst_data) {
    let exists_layers = this.getLayer(this._fcstTracks, fcst_data.tc_name, fcst_data.src, fcst_data.init_time_z)
    if (exists_layers.length === 0) {
      let points = {
        points: TrackHandler.collect_fcst_points(fcst_data.track, fcst_data.init_time_z)
      }

      let tc_info = this.get_tc_info(fcst_data.tc_name)
      let src_info = this.get_src_info(fcst_data.src)

      if (tc_info && src_info) {
        let opacity = 0.7
        if (this._isOldFcstData(fcst_data)) {
          opacity = 0.35
        }

        let fcst_track = new L.TyphoonTW.FcstTrack(
          points, {
            markerOptions: {
              iconCase: L.TyphoonTW.TrackIconCase,
              source_color: src_info.color,
              icon_size: CycloneMarkerOptions.icon_size
            },
            color: src_info.color,
            weight: 2,
            opacity: opacity,
            markerVisible: true,
            timeLabelTimeList: this.collect_timelabel_time()
          },
          fcst_data.src,
          this._data.src_infos,
          tc_info,
          this._options.selected_init_time_z
        )
        fcst_track.bindSrcName()
        fcst_track.bindTimeLabelHub(this)
        this._fcstTracks.push(fcst_track)
        return [fcst_track, true]
      }
    }
    return [exists_layers[0], false]
  }

  _updateLayers (layers, selected_tcs, selected_srcs, init_time_zs) {
    for (let _layer of layers) {
      if (selected_tcs.includes(_layer.get_tc_info().name) &&
          selected_srcs.includes(_layer.get_src()) &&
          init_time_zs.includes(_layer.get_init_time_z())
      ) {
        // todo
        if (!this._map.hasLayer(_layer)) {
          this._map.addLayer(_layer)
        }
      } else {
        if (this._map.hasLayer(_layer)) {
          this._map.removeLayer(_layer)
        }
      }
      if (_layer.setSrcNameVisible) {
        _layer.setSrcNameVisible(this._options.show_src_name)
      }
    }
  }

  get_src_info (src) {
    let [src_info] = this._data.src_infos.filter((e) => {
      return e.id === src})
    return src_info
  }

  get_tc_info (tc_name) {
    let [tc_info] = this._data.tc_infos.filter((e) => {
      return e.name === tc_name })
    return tc_info
  }

  getLayer (layers, tc, src, init_time_z = null) {
    return layers.filter((e) => {
      return e.get_src() === src && e.get_tc_info().name === tc && (!init_time_z || e.get_init_time_z() === init_time_z)
    })
  }

  set_availible_init_time_z () {
    this._past_all_init_time_z.splice(0)
    this._fcst_all_init_time_z.splice(0)

    if (this._data.track.fcst) {
      for (let _fcst of this._data.track.fcst) {
        this._fcst_all_init_time_z.push(_fcst.init_time_z)
      }
    }

    let _past_track = null
    if (this._data.track.past) {
      for (let _past of this._data.track.past) {
        _past_track = _past.track
        if (_past_track.length > 0) {
          this._past_all_init_time_z.push(_past_track[0].fixtime)
        }
      }
    }
  }

  collect_timelabel_time () {
    return this._timeLabelTau.map((x) =>{
      return Date.dtgptime(this._options.selected_init_time_z).addHours(x).dtgftime()
    })
  }

  _isOldFcstData (fcst_data) {
    let newest_init_time = Math.max(...this._fcst_all_init_time_z.map(x => parseInt(x)))

    return parseInt(fcst_data.init_time_z) === newest_init_time
  }

  static filter_src_tc (data, tcs, srcs, init_time_zs) {
    return data.filter((e) => {
      let match = true
      if (tcs) {
        match = match || tcs.includes(e.tc_name)
      }
      if (srcs) {
        match = match || srcs.includes(e.src)
      }
      return match
    })
  }

  static collect_past_points (track) {
    let points = {}
    for (let _point of track) {
      let _dtime = _point['fixtime']
      points[_dtime] = {
        lat: _point['lat'],
        lon: _point['lon'],
        ws: _point['ws']
      }
    }
    return points
  }

  static collect_fcst_points (track, init_time_z) {
    let points = {}
    for (let _point of track) {
      let _dtime = Date.dtgptime(init_time_z).addHours(_point.tau).dtgftime()
      points[_dtime] = {
        tau: _point['tau'],
        lat: _point['lat'],
        lon: _point['lon'],
        ws: _point['ws']
      }
    }
    return points
  }
}



// WEBPACK FOOTER //
// ./src/assets/leaflet/track/index.js